import { render } from "./generator.vue?vue&type=template&id=92da49a4"
import script from "./generator.js?vue&type=script&lang=js&external"
export * from "./generator.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__